export const SELECT_BRUSH_COLOR = "SELECT_BRUSH_COLOR";
export const SELECT_BRUSH_WEIGHT = "SELECT_BRUSH_WEIGHT";
export const SAVE_CANVAS_LINES = "SAVE_CANVAS_LINES";
export const LOAD_CANVAS_LINES = "LOAD_CANVAS_LINES";
export const HISTORY_CANVAS_STEPS_BACK = "HISTORY_CANVAS_STEPS_BACK";
export const HISTORY_CANVAS_STEPS_FORWARD = "HISTORY_CANVAS_STEPS_FORWARD";
export const LOAD_PALETTE_COLORS = "LOAD_PALETTE_COLORS";
export const SELECT_PALETTE_COLOR = "SELECT_PALETTE_COLOR";
export const SELECT_WEIGHT = "SELECT_WEIGHT";
export const LOAD_WEIGHTS = "LOAD_WEIGHTS";
